import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { getBulkMemberPriceHistory } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';

class BulkUpdateMemberPriceHistoryList extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.init(this.props.branchId);
    }
    changePage = e => {
        this.setState({ activePage: e });
        this.props.init(e, this.state.itemsPerPage);
    }
    render() {
        const p = this.props;
        const listBulkHistory = p.history.map((item) => {
            return {
                userTitle: (<Link to={`/employee/edit/${item.userId}`}>{item.userTitle}</Link>),
                memberDiscountPercentage: (item.percepercentageDiscountntage != null ? item.percepercentageDiscountntage : "-"),
                updateCount: (item.updateCount != null ? item.updateCount : "-"),
                creationDate: (item.creationDate != null ? moment(item.creationDate).format('YYYY-MM-DD') : "-")
            };
        });

        return (
            <div className="row pb-2 pl-2" style={{ overflowY: `scroll`, overflowX: `hidden`, maxHeight: `400px` }}>

                <Grid>
                    <div className="row m-0 pa-0">
                        <div className="col-lg-6 col-sm-6 col-xs-5">
                            <h5>{this.props.title}</h5>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-xs-7 text-right mt-20px">

                        </div>
                    </div>
                    <div className="list-table-last list-table">
                        <CardSimple>
                            <div className="form-group">
                                <GenericTable
                                    className="table_center tableHeaderwhiteColorFont"
                                    stripedRows={true}
                                    columns={LOOKUP.product.tableColumnsBulkMemberPriceHistory}
                                    rows={listBulkHistory} />
                            </div>
                        </CardSimple>
                    </div>
                </Grid>
            </div>
        );
    }
}
function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        history: state.entity.bulkUpdateMemberPriceHistoryList,
        history_lenght: state.entity.bulkUpdateMemberPriceHistoryListLength
    };
}
function mapDispatchToProps(dispatch) {
    return {
        init: (branchId) => dispatch(getBulkMemberPriceHistory(branchId))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(BulkUpdateMemberPriceHistoryList);
